import { useEffect, useState } from 'react'
import type { CloudMovieRecord, CloudSeriesRecord } from '@govu/shared'
import { useLibraryAdapter } from '../data/DataAdapterProvider'

export interface LibraryMovieEntry {
  tmdbId: number
  record: CloudMovieRecord
}

export interface LibrarySeriesEntry {
  tmdbId: number
  record: CloudSeriesRecord
}

/**
 * Subscribes to the user's movie library via the active LibraryAdapter
 * (Firestore today, IpcLibraryAdapter on the desktop in the future).
 * Same external shape as before — components downstream don't have to
 * know we route through the adapter.
 */
export function useLibraryMovies(): {
  entries: LibraryMovieEntry[]
  loading: boolean
} {
  const adapter = useLibraryAdapter()
  const [entries, setEntries] = useState<LibraryMovieEntry[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    const unsub = adapter.subscribeMovies((next) => {
      setEntries(next)
      setLoading(false)
    })
    return unsub
  }, [adapter])

  return { entries, loading }
}

export function useLibrarySeries(): {
  entries: LibrarySeriesEntry[]
  loading: boolean
} {
  const adapter = useLibraryAdapter()
  const [entries, setEntries] = useState<LibrarySeriesEntry[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    const unsub = adapter.subscribeSeries((next) => {
      setEntries(next)
      setLoading(false)
    })
    return unsub
  }, [adapter])

  return { entries, loading }
}
